export function formatCurrency(value: unknown): string {
  if (value === null || value === undefined || value === '') return 'N/A'
  // Coerce safely to number using String() to avoid passing objects directly to Number
  const num = typeof value === 'number' ? value : Number(String(value))
  return Number.isFinite(num) ? `tsh${num.toFixed(2)}` : 'N/A'
}

export function formatCurrencyMaybe(value: unknown): string {
  // variant that returns '-' for empty values (used in lists)
  if (value === null || value === undefined || value === '') return '-'
  const num = typeof value === 'number' ? value : Number(String(value))
  return Number.isFinite(num) ? `tsh${num.toFixed(2)}` : '-'
}
